export class Company {
  constructor({
    companyID = 0,
    companyName = null,
    tradingName = null,
    entityType = null,
    directorSurname = null,
    abn = null,
    acn = null,
    driversLicenseNumber = null,
    dateOfBirth = new Date(1970, 1, 1),
    directorGivenName = null,
    otherOrganisation = false,
    guaranteeAttached = false,
    dobConsumer = new Date(),
    isdirectorSurnameRequired = false,
    isdateOfBirthRequired = false,
    industry = "Q",
    subIndustry = "QA",
    abn_status_from_date = null
  } = {}) {
    this.companyID = companyID;
    this.companyName = companyName;
    this.tradingName = tradingName;
    this.entityType = entityType;
    this.directorSurname = directorSurname;
    this.abn = abn;
    this.acn = acn;
    this.driversLicenseNumber = driversLicenseNumber;
    this.dateOfBirth = dateOfBirth;
    this.directorGivenName = directorGivenName;
    this.otherOrganisation = otherOrganisation;
    this.guaranteeAttached = guaranteeAttached;
    this.dobConsumer = dobConsumer;
    this.isdirectorSurnameRequired = isdirectorSurnameRequired;
    this.isdateOfBirthRequired = isdateOfBirthRequired;
    this.industry = industry;
    this.subIndustry = subIndustry;
    this.abn_status_from_date = abn_status_from_date;
  }
}

export function createCompany(data) {
  return Object.freeze(new Company(data));
}
